import { render, staticRenderFns } from "./Controle.vue?vue&type=template&id=2c833676&"
import script from "./Controle.vue?vue&type=script&lang=js&"
export * from "./Controle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Controle.vue"
export default component.exports